<template>
  <nav>
    <ul class="pagination pagination-sm mb-0 flex-wrap">
      <li
          v-for="i in pages"
          :key="i"
          class="page-item mb-1"
          :class="{active: i==page+1}"
      >
        <a @click="$emit('click-page', i-1)" class="page-link" href="#">{{ i }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ["pages", "page"],
  emits: "click-page",
}
</script>

